import { Flex } from '../../../../common/Flex';
import { Button, Checkbox, Select } from 'antd';
import React, { PureComponent } from 'react';
import { SettingsContentPanel } from '../../../../common/SettingsContentPanel';

export const DEFAULT_FLOW_SETTINGS: FlowSettings = {
    sortBy: 'name',
    tv: 'all',
    showOccupancy: true,
    occupancy: 'all',
    showOccupancyForTv: true,
    occupancyForTv: 'all',
    showLoadInactivePeriods: false,
};

export interface FlowSettings {
    sortBy: 'name';
    tv: 'all' | 'low' | 'high' | 'overload';
    showOccupancy: boolean;
    occupancy: 'all' | 'sustain' | 'peak';
    showOccupancyForTv: boolean;
    occupancyForTv: 'all' | 'low' | 'high' | 'overload';
    showLoadInactivePeriods: boolean;
}

interface FlowSettingsTitleProps {
    flowName: string;
}

export class FlowSettingsTitle extends PureComponent<FlowSettingsTitleProps> {
    render() {
        return (
            <Flex direction="vertical">
                <div style={{ fontWeight: 'bold' }}>SECTION SETTINGS</div>
                <div style={{ fontSize: '0.8em' }}>{this.props.flowName}</div>
            </Flex>
        );
    }
}

export class FlowSettingsContent extends SettingsContentPanel<FlowSettings> {
    render() {
        return (
            <Flex direction="vertical" className="settings-content" style={{ width: '26em', padding: '1em' }}>
                <Flex>
                    <Flex className="label">Sort by</Flex>
                    <Flex size="12em">
                        <Select
                            value={this.state.sortBy}
                            disabled={true}
                            onChange={value => this.setState({ sortBy: value })}
                            style={{ width: '12em' }}
                            // Force render  of dropdown inside the popover content
                            // Fix popover hiding on click
                            getPopupContainer={trigger => trigger.parentNode}>
                            <Select.Option value="name">Name</Select.Option>
                        </Select>
                    </Flex>
                </Flex>
                <Flex>
                    <Flex className="label">TVs to show</Flex>
                    <Flex size="12em">
                        <Select
                            value={this.state.tv}
                            onChange={value => this.setState({ tv: value })}
                            style={{ width: '12em' }}
                            // Force render  of dropdown inside the popover content
                            // Fix popover hiding on click
                            getPopupContainer={trigger => trigger.parentNode}>
                            <Select.Option value="all">All</Select.Option>
                            <Select.Option value="low">Low threshold</Select.Option>
                            <Select.Option value="high">High threshold</Select.Option>
                            <Select.Option value="overload">Overload</Select.Option>
                        </Select>
                    </Flex>
                </Flex>
                <Flex>
                    <Flex className="label">
                        <Checkbox
                            checked={this.state.showOccupancy}
                            onChange={value => this.setState({ showOccupancy: value.target.checked })}>
                            Show occupancy
                        </Checkbox>
                    </Flex>
                    <Flex size="12em">
                        <Select
                            value={this.state.occupancy}
                            disabled={!this.state.showOccupancy}
                            onChange={value => this.setState({ occupancy: value })}
                            style={{ width: '12em' }}
                            // Force render  of dropdown inside the popover content
                            // Fix popover hiding on click
                            getPopupContainer={trigger => trigger.parentNode}>
                            <Select.Option value="all">All</Select.Option>
                            <Select.Option value="sustain">Sustain value</Select.Option>
                            <Select.Option value="peak">Peak value</Select.Option>
                        </Select>
                    </Flex>
                </Flex>
                <Flex>
                    <Flex className="label">
                        <Checkbox
                            checked={this.state.showOccupancyForTv}
                            disabled={!this.state.showOccupancy}
                            onChange={value => this.setState({ showOccupancyForTv: value.target.checked })}>
                            Only for TVs
                        </Checkbox>
                    </Flex>
                    <Flex size="12em">
                        <Select
                            value={this.state.occupancyForTv}
                            disabled={!this.state.showOccupancy || !this.state.showOccupancyForTv}
                            onChange={value => this.setState({ occupancyForTv: value })}
                            style={{ width: '12em' }}
                            // Force render  of dropdown inside the popover content
                            // Fix popover hiding on click
                            getPopupContainer={trigger => trigger.parentNode}>
                            <Select.Option value="all">All</Select.Option>
                            <Select.Option value="low">Low threshold</Select.Option>
                            <Select.Option value="high">High threshold</Select.Option>
                            <Select.Option value="overload">Overload</Select.Option>
                        </Select>
                    </Flex>
                </Flex>
                <Flex>
                    <Flex className="label">
                        <Checkbox
                            checked={this.state.showLoadInactivePeriods}
                            onChange={e => this.setState({ showLoadInactivePeriods: e.target.checked })}>
                            Show load for non-active periods
                        </Checkbox>
                    </Flex>
                </Flex>
                <Flex style={{ justifyContent: 'space-around' }}>
                    <Button onClick={this.handleApply}>Apply</Button>
                    <Button onClick={this.handleClose}>Close</Button>
                </Flex>
            </Flex>
        );
    }
}
